import { defineAsyncComponent } from '../compat/vueCompat';
import type { DownloadPremiereMediaDialogRequest } from './downloadPremiereMediaDialogRequest';
import { requestDialog } from './requestDialog';

const DownloadPremiereMediaDialog = defineAsyncComponent(() => import('@mimir/web/components/Common/Dialogs/dialogs/DownloadPremiereMediaDialog.vue'));

export function showDownloadPremiereMediaDialog(req: DownloadPremiereMediaDialogRequest) {
  requestDialog(req, DownloadPremiereMediaDialog);
}
